import { createContext, useContext, useMemo, useCallback } from "react";
import { createBotMessage } from "utils/utils";
import { condition } from "./condition";
import { Globalstate } from "./context";
import { nanoid } from "nanoid";
import { WEB_SOCKET_BASE_URL } from "config";

const WebSocketContext = createContext(null);

export const useWebSocket = () => {
  return useContext(WebSocketContext);
};
export const WebSocketProvider = ({ children }) => {
  const { state, dispatch } = Globalstate();
  const sendMessage = useCallback(
    (message) => {
      const ws = new WebSocket(`${WEB_SOCKET_BASE_URL}/stream`);
      const handleError = () => {
        dispatch({ type: condition.ISMESSAGESUBMITTED, payload: false });
        const botMessage = {
          key: "",
          answer: "Something Went Wrong! Please Try Again Later",
          cta_results: [],
          recommended_questions: [],
          id: "",
          messageSender: "bot",
          question: message?.query
        };
        dispatch({ type: condition.UPDATELASTMESSAGE, payload: botMessage });
      };
      ws.addEventListener("error", handleError);

      const handleWebSocketOpen = () => {
        dispatch({ type: condition.ISMESSAGESUBMITTED, payload: true });
        ws.send(
          JSON.stringify({
            ...message,
            model: process.env.REACT_APP_GPT_MODEL,
            conversation_id: localStorage.getItem("authToken"),
            source: message?.source == "service" ? "service" : "ABCD",
            follow_up_flag: message.follow_up_flag
              ? message.follow_up_flag
              : false,
            lang_code: message?.lang_code ? message?.lang_code : "en-IN"
          })
        );
        ws.onmessage = handleWebSocketMessage;
      };

      const handleWebSocketMessage = (event) => {
        const response = JSON.parse(event.data);
        dispatch({
          type: condition.UPDATELASTMESSAGE,
          payload: {
            ...response,
            question: message?.query,
            key: message?.botKey,
            unavailability_flag: response.unavailability_flag
          }
        });
      };
      ws.addEventListener("open", handleWebSocketOpen);
      ws.onclose = () => {
        dispatch({ type: condition.ISMESSAGESUBMITTED, payload: false });
      };
    },
    [dispatch]
  );
  const sendMessageBingSearch = useCallback(
    (message) => {
      const ws = new WebSocket(`${WEB_SOCKET_BASE_URL}/bing_stream`);

      const handleError = () => {
        dispatch({ type: condition.ISMESSAGESUBMITTED, payload: false });
        const botMessage = {
          answer: "Something Went Wrong! Please Try Again Later",
          cta_results: [],
          recommended_questions: [],
          id: "",
          isBingResponse: true
        };
        dispatch({
          type: condition.UPDATELASTMESSAGE,
          payload: {
            ...botMessage,
            question: message?.query,
            key: message?.botKey
          }
        });
      };
      ws.addEventListener("error", handleError);

      const handleWebSocketOpen = () => {
        dispatch({ type: condition.ISMESSAGESUBMITTED, payload: true });
        ws.send(
          JSON.stringify({
            id: message.id,
            model: process.env.REACT_APP_GPT_MODEL,
            conversation_id: localStorage.getItem("authToken"),
            source: (state.source == "service" || message?.source == "service") ? "service" : "ABCD"
          })
        );
        ws.onmessage = handleWebSocketMessage;
      };

      const handleWebSocketMessage = (event) => {
        const response = JSON.parse(event.data);
        dispatch({
          type: condition.UPDATELASTMESSAGE,
          payload: {
            ...{ ...response, question: message?.query, isBingResponse: true },
            key: message?.botKey
          }
        });
      };
      ws.addEventListener("open", handleWebSocketOpen);

      ws.onclose = () => {
        dispatch({ type: condition.ISMESSAGESUBMITTED, payload: false });
      };
    },
    [dispatch]
  );

  const contextValue = useMemo(
    () => ({
      sendMessage,
      sendMessageBingSearch
    }),
    [sendMessage, sendMessageBingSearch]
  );
  return (
    <WebSocketContext.Provider value={contextValue}>
      {children}
    </WebSocketContext.Provider>
  );
};
